import React, { useState, useEffect, useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { useExcelExport } from '../../../CustomHooks/useExcelExport';
import './Notas.scss';
import TitleView from '../../../components/atoms/TitleView/TitleView';
import { getNotas } from './integracion';
import { formateoBasico } from '../../../utilities/formateos';

const columnasExport = [
    { field: 'ID', header: 'ID' },
    { field: 'ID_BITACORA', header: 'ID Bitácora' },
    { field: 'FECHA', header: 'Fecha' },
    { field: 'NOTA', header: 'Nota' },
    { field: 'ID_USUARIO_REGISTRO', header: 'Usuario Registro' },
    { field: 'ID_USUARIO_REVISION', header: 'Usuario Revisión' },
    { field: 'FECHA_REVISION', header: 'Fecha Revisión' },
    { field: 'REVISADO', header: 'Revisado' }
];

const Notas = () => {
    const hoy = new Date();
    const [notas, setNotas] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [fechaInicio, setFechaInicio] = useState(hoy);
    const [fechaFin, setFechaFin] = useState(hoy);
    const { exportarAExcel } = useExcelExport();

    useEffect(() => {
        fetchNotas();
    }, [fechaInicio, fechaFin]); // Ejecutar cuando cambien las fechas

    const fetchNotas = async () => {
        try {
            const response = await getNotas(formateoBasico(fechaInicio), formateoBasico(fechaFin));
            setNotas(response || []);
        } catch (error) {
            console.error("Error fetching notas:", error);
            setNotas([]);
        }
    };

    // Filtrado optimizado con useMemo
    const notasFiltradas = useMemo(() => {
        if (!notas || notas.length === 0) return [];
        
        if (!globalFilter.trim()) return notas;

        const query = globalFilter.toLowerCase().trim();
        
        return notas.filter(nota => {
            // Filtrar por todos los campos relevantes
            const id = String(nota.ID || '').toLowerCase();
            const idBitacora = String(nota.ID_BITACORA || '').toLowerCase();
            const notaText = String(nota.NOTA || '').toLowerCase();
            const usuarioRegistro = String(nota.ID_USUARIO_REGISTRO || '').toLowerCase();
            const usuarioRevision = String(nota.ID_USUARIO_REVISION || '').toLowerCase();
            const revisado = nota.REVISADO ? 'si' : 'no';
            
            return (
                id.includes(query) ||
                idBitacora.includes(query) ||
                notaText.includes(query) ||
                usuarioRegistro.includes(query) ||
                usuarioRevision.includes(query) ||
                revisado.includes(query)
            );
        });
    }, [notas, globalFilter]);

    const revisadoTemplate = (rowData) => (
        <Checkbox checked={rowData.REVISADO} disabled />
    );

    const fechaTemplate = (rowData, field) => (
        rowData[field] ? new Date(rowData[field]).toLocaleString() : ''
    );
    console.log("notas",notas);
    
    return (
        <div className="reporte-notas-container">
            <TitleView title="Reporte de Notas" />
            <div className='containeView'>
                <div className="filtros-notas">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilter}
                            onChange={(e) => setGlobalFilter(e.target.value)}
                            placeholder="Buscar en todas las columnas..."
                            style={{ width: '300px' }}
                        />
                    </span>
                    <Calendar
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.value)}
                        placeholder="Fecha inicio"
                        dateFormat="dd/mm/yy"
                        showIcon
                    />
                    <Calendar
                        value={fechaFin}
                        onChange={(e) => setFechaFin(e.value)}
                        placeholder="Fecha fin"
                        dateFormat="dd/mm/yy"
                        showIcon
                    />
                    <Button
                        label="Consultar"
                        icon="pi pi-search"
                        className="p-button-primary"
                        onClick={fetchNotas}
                    />
                    <Button
                        label="Descargar Excel"
                        icon="pi pi-file-excel"
                        className="p-button-success"
                        onClick={() => exportarAExcel(notasFiltradas, columnasExport, 'ReporteNotas')}
                        disabled={notasFiltradas.length === 0}
                    />
                </div>
                
                <div style={{ marginTop: '10px', marginBottom: '10px', color: '#666' }}>
                    <small>
                        Mostrando {notasFiltradas.length} de {notas.length} nota(s)
                    </small>
                </div>
                    
                
                <DataTable
                    value={notasFiltradas}
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    responsiveLayout="scroll"
                    emptyMessage="No hay notas para mostrar"
                    className="p-datatable-sm"
                   
                >
                    <Column field="ID" header="ID" sortable style={{ width: '80px' }} />
                    <Column field="ID_BITACORA" header="ID Bitácora" sortable style={{ width: '120px' }} />
                    <Column field="FECHA" header="Fecha" body={(rowData) => fechaTemplate(rowData, 'FECHA')} sortable style={{ width: '180px' }} />
                    <Column field="NOTA" header="Nota" style={{ minWidth: '250px' }} />
                    <Column field="NOMBRE_USUARIO_REGISTRO" header="Usuario Registro" sortable style={{ width: '150px' }} />
                    <Column field="NOMBRE_USUARIO_REVISION" header="Usuario Revisión" sortable style={{ width: '150px' }} />
                    <Column field="FECHA_REVISION" header="Fecha Revisión" body={(rowData) => fechaTemplate(rowData, 'FECHA_REVISION')} sortable style={{ width: '180px' }} />
                    <Column field="REVISADO" header="Revisado" body={revisadoTemplate} sortable style={{ width: '100px', textAlign: 'center' }} />
                </DataTable>
            </div>
        </div>
    );
};

export default Notas;
